import { ref } from 'vue';

export const isShowMenuPhone = ref(false);
export const isShowQrCodeDialog = ref(false);
